import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

/**
 * 로그인 여부를 확인하여 비로그인 시 /login으로 리다이렉트하는 가드 컴포넌트
 */
const AuthGuard = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const userToken = localStorage.getItem('userToken');
  const contentId = searchParams.get('contentId');

  // 배포 환경에서 trailing slash(`/login/`)로 들어오는 케이스를 허용하기 위해 path를 정규화
  const normalizedPathname = pathname.replace(/\/+$/, '') || '/';
  const isLoginRoute = normalizedPathname.startsWith('/login');
  const isEditRoute = normalizedPathname.startsWith('/edit');

  // PA에서 에디터로 직접 진입 시, adminToken 유무를 확인하여 진입 가능 여부를 결정
  if (isEditRoute && contentId) {
    /**
     * @title PA 최초 진입 시
     * 1. adminToken이 있으면 진입 가능 (기존 카카오 로그인 세션은 제거)
     * 2. adminToken을 세션 스토리지에 저장하고 /edit?contentId=${contentId}&fromPA=true 리다이렉트
          (PA 사용자는 탭을 닫거나, 브라우저 종료 시, 세션 종료가 필요하므로, 세션 스토리지를 사용합니다.)
    */
    const adminToken = searchParams.get('adminToken');
    if (adminToken) {
      localStorage.removeItem('userToken');
      sessionStorage.setItem('userToken', adminToken);
      return <Navigate to={`/edit?contentId=${contentId}`} replace />;
    }

    /**
     * @title PA 진입 후 새로고침 시
     * 1. 세션 스토리지에 userToken이 있으면 진입 가능
     */
    const hasSavedAdminToken = sessionStorage.getItem('userToken');
    if (hasSavedAdminToken) {
      return <Outlet />;
    }

    sessionStorage.removeItem('userToken');
  }

  /**
   * @description 로그인 페이지 진입 시, 세션 스토리지에 저장된 adminToken을 제거
   * @link https://bbros-lab.slack.com/archives/C09V0U85BAA/p1768803403161989?thread_ts=1768801292.030949&cid=C09V0U85BAA
   */
  if (isLoginRoute) {
    const hasSavedAdminToken = sessionStorage.getItem('userToken');
    if (hasSavedAdminToken) {
      sessionStorage.removeItem('userToken');
      return <Outlet />;
    }
  }

  // 비로그인: /login만 접근 가능
  if (!userToken && !isLoginRoute) {
    return <Navigate to="/login" replace />;
  }

  // 로그인: /login 접근 불가 (홈으로)
  if (userToken && isLoginRoute) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
